import { EventReportFilter } from '@contexts/event-report/event-report-context.type';
import { ExportType, SeparatorType } from '@hooks/use-customers-page-reducer/use-customers-page-reducer-types';
import { useGenericQuery } from '@hooks/use-generic-query';
import { Params, paramsSerializer } from '@utils/format-params';
import { RequestError, RequestMethod } from '@utils/request/request.type';
import { requestDownload } from '@utils/request/request-download';

import { QUERY_KEYS } from './constants';
import { EventBookingParams } from './use-get-event-bookings';

interface ExportBookingParams extends EventBookingParams {
  fileType?: ExportType;
  separator?: SeparatorType;
}

interface ExportBookingParams {
  eventId?: string;
  params?: ExportBookingParams;
  options?: Record<string, boolean | number>;
}

export const createEventReportExportBookingsKey = (eventId: string | undefined, params?: EventReportFilter) => [
  QUERY_KEYS.eventReportExportBookings,
  eventId,
  params,
];

const getEventExport = async ({ eventId, params }: ExportBookingParams) => {
  const queryParams = paramsSerializer(params as Params);
  const url = `${import.meta.env.VITE_MONOLITH_HOST}/v1/nightgraph/events/${eventId}/export?${queryParams}`;

  return requestDownload({ url, method: RequestMethod.GET, headers: { responseType: 'blob' } });
};

export const useExportBookings = ({ eventId, params, options }: ExportBookingParams) => {
  return useGenericQuery<Blob, RequestError>(
    createEventReportExportBookingsKey(eventId, params),
    () => getEventExport({ eventId, params }),
    {
      ...options,
    }
  );
};
